// Central registry of data-testid values used across the app.
// Testing agent relies on these — keep names stable.

export const HOME = {
    root: 'home-page',
    heroHeading: 'hero-heading',
    heroTagline: 'hero-tagline',
    ctaEnterLab: 'cta-enter-lab',
    ctaExplorePaths: 'cta-explore-paths',
    sectionWho: 'section-who',
    sectionPathways: 'section-pathways',
    sectionPlay: 'section-play',
    sectionCommunity: 'section-community',
    sectionMembership: 'section-membership',
    sectionNewsletter: 'section-newsletter',
    newsletterInput: 'newsletter-email-input',
    newsletterSubmit: 'newsletter-submit',
    newsletterSuccess: 'newsletter-success',
    emergentLink: 'home-emergent-link',
};

export const NAV = {
    root: 'hud-nav',
    linkLab: 'nav-link-lab',
    linkLearn: 'nav-link-learn',
    linkPlay: 'nav-link-play',
    linkBuild: 'nav-link-build',
    linkCommunity: 'nav-link-community',
    linkMembership: 'nav-link-membership',
    linkShop: 'nav-link-shop',
    linkHub: 'nav-link-hub',
    linkLog: 'nav-link-log',
    linkLibrary: 'nav-link-library',
    linkFreeDrill: 'nav-link-free-drill',
    linkVerify: 'nav-link-verify',
    linkLabs: 'nav-link-labs',
    menuToggle: 'nav-menu-toggle',
};

export const LEARN = {
    root: 'learn-root',
    map: 'learn-map',
    node: (id) => `knowledge-node-${id}`,
    controls: 'learn-controls',
    search: 'learn-search',
    chip: (slug) => `learn-chip-${slug}`,
    conceptCard: 'learn-concept-card',
    conceptClose: 'learn-concept-close',
    emptyState: 'learn-empty-state',
};

export const PLAY = {
    root: 'play-page',
    game: (id) => `game-card-${id}`,
    neuronGrid: 'neuron-grid',
    neuron: (id) => `neuron-${id}`,
    factCard: 'neuron-fact-card',
    factClose: 'neuron-fact-close',
    resetGame: 'neuron-reset',
};

export const BUILD = {
    root: 'build-page',
    pipeline: 'pipeline-diagram',
    stage: (id) => `pipeline-stage-${id}`,
};

export const COMMUNITY = {
    root: 'community-page',
    card: (id) => `community-card-${id}`,
};

export const MEMBERSHIP = {
    root: 'membership-page',
    tier: (id) => `tier-card-${id}`,
    joinBtn: (id) => `tier-join-${id}`,
    waitlistInput: 'membership-waitlist-input',
    waitlistSubmit: 'membership-waitlist-submit',
    waitlistSuccess: 'membership-waitlist-success',
};

export const SHOP = {
    root: 'shop-page',
    categorySection: (cat) => `shop-category-${cat}`,
    card: (slug) => `product-card-${slug}`,
    cardNotify: (slug) => `product-notify-${slug}`,
    detailRoot: 'product-detail-page',
    detailNotify: 'product-detail-notify',
    notifyInput: 'product-notify-input',
    notifySubmit: 'product-notify-submit',
    notifySuccess: 'product-notify-success',
    filesList: 'product-files-list',
    requirementsList: 'product-requirements-list',
    homeTeaser: 'home-shop-teaser',
    homeTeaserCard: (slug) => `home-shop-card-${slug}`,
};

export const LOG = {
    root: 'log-page',
    timeline: 'log-timeline',
    entry: (n) => `log-entry-${n}`,
    entryToggle: (n) => `log-entry-toggle-${n}`,
    entryBody: (n) => `log-entry-body-${n}`,
    homeTeaser: 'home-log-teaser',
};

export const LIBRARY = {
    root: 'library-page',
    searchInput: 'library-search',
    categoryFilter: (cat) => `library-cat-${cat}`,
    typeFilter: (t) => `library-type-${t}`,
    clearFilters: 'library-clear-filters',
    featuredSection: 'library-featured',
    grid: 'library-grid',
    card: (slug) => `library-card-${slug}`,
    cardOpen: (slug) => `library-card-open-${slug}`,
    videoModal: 'library-video-modal',
    videoModalClose: 'library-video-modal-close',
    homeTeaser: 'home-library-teaser',
    empty: 'library-empty-state',
};

export const ARCHIVE = {
    trigger: 'archive-menu-trigger',
    panel: 'archive-menu-panel',
    linkLearn: 'archive-link-learn',
    linkFreeDrill: 'archive-link-free-drill',
    linkLibrary: 'archive-link-library',
    linkLog: 'archive-link-log',
};

export const PLAY_ACCESS = {
    tierBadge: (id) => `game-tier-${id}`,
    lockCta: (id) => `game-lock-cta-${id}`,
};

export const BUILD_EXT = {
    auditPipeline: 'audit-pipeline',
    auditStage: (id) => `audit-stage-${id}`,
    famousPipelines: 'famous-pipelines-section',
    famousPipeline: (id) => `famous-pipeline-${id}`,
    resourcesSection: 'build-resources-section',
    resourceCard: (id) => `build-resource-${id}`,
};

export const ROADMAP = {
    root: 'roadmap-page',
    hero: 'roadmap-hero',
    timeline: 'roadmap-timeline',
    phase: (id) => `roadmap-phase-${id}`,
    pillars: 'roadmap-pillars',
    pillar: (id) => `roadmap-pillar-${id}`,
    checks: 'roadmap-checks',
    check: (id) => `roadmap-check-${id}`,
    closing: 'roadmap-closing',
    ctaWaitlist: 'roadmap-cta-waitlist',
    ctaAcademy: 'roadmap-cta-academy',
    waitlistInput: 'roadmap-waitlist-input',
    waitlistSubmit: 'roadmap-waitlist-submit',
    waitlistSuccess: 'roadmap-waitlist-success',
    homeTeaser: 'home-roadmap-teaser',
    footerLink: 'footer-roadmap-link',
    navLink: 'nav-link-roadmap',
    archiveLink: 'archive-link-roadmap',
};

export const VERIFY = {
    // /verify — upload page
    root: 'verify-page',
    dropzone: 'verify-upload-dropzone',
    fileInput: 'verify-file-input',
    submit: 'verify-upload-submit',
    progressBar: 'verify-upload-progress',
    errorAlert: 'verify-upload-error',
    // /verify/history
    historyRoot: 'verify-history',
    historyRow: (id) => `verify-history-row-${id}`,
    // Report card + report page
    reportCard: (id) => `verify-report-${id}`,
    reportRoot: 'verify-report-detail',
    reportChipVerified: 'verify-chip-verified',
    reportChipDegraded: 'verify-chip-degraded',
    reportChipAbsent: 'verify-chip-absent',
    reportSection: (name) => `verify-section-${name}`,
    // Share controls
    shareToggle: 'verify-share-toggle',
    shareExpiry: (val) => `verify-share-expiry-${val}`,
    shareUrlCopy: 'verify-share-url-copy',
    // Public view
    publicRoot: 'verify-public',
    publicExpired: 'verify-public-expired',
    publicNotFound: 'verify-public-not-found',
    // Verify V1 (round 3.3)
    matchCode: 'verify-match-code',
    matchCodeValue: 'verify-match-code-value',
    matchCodeCopy: 'verify-match-code-copy',
    fullHash: 'verify-full-hash',
    fullHashCopy: 'verify-full-hash-copy',
    vouch: (name) => `verify-vouch-${name}`,
    checksSummary: 'verify-checks-summary',
    sectionState: (name) => `verify-section-state-${name}`,
    sectionReason: (name) => `verify-section-reason-${name}`,
    hashCheck: 'verify-hash-check',
    hashCheckInput: 'verify-hash-check-input',
    hashCheckPick: 'verify-hash-check-pick',
    hashCheckResult: 'verify-hash-check-result',
    hashCheckError: 'verify-hash-check-error',
    // Verify V2 (prototype, flagged off)
    signedRecords: 'verify-signed-records',
    signedRecord: (id) => `verify-signed-record-${id}`,
    signRecordBtn: 'verify-sign-record',
    signRecordError: 'verify-sign-record-error',
    recordCheck: (id, what) => `verify-record-check-${id}-${what}`,
    uploadScan: 'verify-upload-scan',
    keysPage: 'verify-keys',
    keysCreate: 'verify-keys-create',
    keysLabel: 'verify-keys-label',
    keyRow: (id) => `verify-key-${id}`,
    keyApprove: (id) => `verify-key-approve-${id}`,
    keyRevoke: (id) => `verify-key-revoke-${id}`,
    copyAlarm: 'verify-copy-alarm',
    keysLink: 'verify-keys-link',
    keysTierNote: 'verify-keys-tier-note',
    keyLog: (id) => `verify-key-log-${id}`,
    experimental: (where) => `verify-experimental-${where}`,
    keyChainAlarm: 'verify-key-chain-alarm',
    // Verify V3 (prototype, flagged off)
    tracking: 'verify-tracking',
    lineage: 'verify-lineage',
    lineageNode: (id) => `verify-lineage-node-${id}`,
    lineageParentSelect: 'verify-lineage-parent',
    lineageSave: 'verify-lineage-save',
    copies: 'verify-copies',
    copiesNone: 'verify-copies-none',
    monitoring: 'verify-monitoring',
    // Verify V4 (prototype, flagged off)
    sha3: 'verify-sha3',
    cryptoPage: 'verify-crypto-inventory',
    cryptoItem: (i) => `verify-crypto-item-${i}`,
    // Verify V5.4 (prototype, flagged off)
    releasePage: 'shop-verify-download',
    releaseSignature: 'shop-release-signature',
    releasePick: 'shop-release-pick',
    releaseInput: 'shop-release-input',
    releaseResult: 'shop-release-result',
};

export const VERIFY_ADMIN = {
    root: 'admin-verify',
    row: (id) => `admin-verify-row-${id}`,
    view: (id) => `admin-verify-view-${id}`,
    purge: (id) => `admin-verify-purge-${id}`,
};

export const CREATOR = {
    // /creators/settings
    settingsRoot: 'creator-settings',
    createForm: 'creator-create-form',
    handleInput: 'creator-handle-input',
    handleError: 'creator-handle-error',
    displayNameInput: 'creator-display-name-input',
    submitCreate: 'creator-create-submit',
    profileCard: (cid) => `creator-profile-${cid}`,
    verificationLevelChip: (cid) => `creator-level-${cid}`,
    // domain block
    domainList: (cid) => `creator-domains-${cid}`,
    domainRow: (cid, domain) => `creator-domain-${cid}-${domain}`,
    addDomainInput: (cid) => `creator-domain-input-${cid}`,
    addDomainMethod: (cid, method) => `creator-domain-method-${cid}-${method}`,
    addDomainSubmit: (cid) => `creator-domain-add-${cid}`,
    challengeInstructions: 'creator-challenge-instructions',
    challengeVerify: 'creator-challenge-verify',
    challengeCopy: (idx) => `creator-challenge-copy-${idx}`,
    reverify: (cid, domain) => `creator-domain-reverify-${cid}-${domain}`,
    remove: (cid, domain) => `creator-domain-remove-${cid}-${domain}`,
    verifyError: 'creator-verify-error',
    verifySuccess: 'creator-verify-success',
};

// Copyright Registry (Phase 2 · Module 2)
// Chip state is asserted by testid, not by label text.
export const COPYRIGHT = {
    chipTier: (label) => `copyright-chip-${label}`,     // owner_declared | domain_bound | manifest_embedded | disputed | revoked
    chipRevoked: 'copyright-chip-revoked',
    chipEvidence: 'copyright-chip-evidence',
    chipCreatorContestedNote: 'copyright-chip-creator-contested',
    // Owner actions
    declareBtn: 'copyright-declare-open',
    declareDialog: 'copyright-declare-dialog',
    declareLicensePicker: 'copyright-declare-license-picker',
    declareLicenseOption: (kind) => `copyright-declare-license-${kind}`,
    declareCustomTerms: 'copyright-declare-custom-terms',
    declareCustomCounter: 'copyright-declare-custom-counter',
    declareRightsStatement: 'copyright-declare-rights-statement',
    declareSubmit: 'copyright-declare-submit',
    declareCancel: 'copyright-declare-cancel',
    declareError: 'copyright-declare-error',
    declareSuccess: 'copyright-declare-success',
    // Missing-creator soft-fail path
    declareNeedsCreatorCta: 'copyright-declare-needs-creator',
    revokeBtn: 'copyright-revoke-open',
    revokeReason: 'copyright-revoke-reason',
    revokeConfirm: 'copyright-revoke-confirm',
    revokeCancel: 'copyright-revoke-cancel',
    // Dispute
    disputeOpenBtn: 'copyright-dispute-open',
    disputeReason: 'copyright-dispute-reason',
    disputeConfirm: 'copyright-dispute-confirm',
    disputeCancel: 'copyright-dispute-cancel',
    disputeSuccess: 'copyright-dispute-success',
    disputeError: 'copyright-dispute-error',
    disputeRateLimit: 'copyright-dispute-ratelimit',
    // Exports
    exportCsvBtn: 'copyright-export-csv',
    receiptDownloadBtn: 'copyright-receipt-download',
    // License reference page
    refLink: 'copyright-license-ref-link',
    declareRefLink: 'copyright-declare-ref-link',
    refRoot: 'license-ref-root',
    refTierCard: (tier) => `license-ref-tier-${tier}`,
    refRow: (kind) => `license-ref-row-${kind}`,
};

export const NOTIF = {
    bell: 'notif-bell',
    badge: 'notif-unread-badge',
    panel: 'notif-panel',
    item: (id) => `notif-item-${id}`,
    markAll: 'notif-mark-all-read',
    empty: 'notif-empty',
    mobileBell: 'notif-bell-mobile',
};

export const REGISTRY = {
    root: 'registry-root',
    hashInput: 'registry-hash-input',
    lookupBtn: 'registry-lookup-btn',
    fileInput: 'registry-file-input',
    fileDrop: 'registry-file-drop',
    results: 'registry-results',
    noRecord: 'registry-no-record',
    entry: (id) => `registry-entry-${id}`,
    error: 'registry-error',
};

export const MANIFESTED = {
    block: 'verify-manifested-block',
    downloadBtn: 'verify-manifested-download',
    error: 'verify-manifested-error',
};

export const BADGE = {
    downloadBtn: 'verify-registry-badge-download',
    error: 'verify-registry-badge-error',
};

export const SMI_MANIFEST = {
    block: 'smi-manifest-block',
    shaMatch: 'smi-manifest-sha-match',
    shaDiffer: 'smi-manifest-sha-differ',
    licenseRow: (id) => `smi-manifest-license-${id}`,
    originalLink: 'smi-manifest-original-link',
};

export const NOTIF_PREFS = {
    gear: 'notif-prefs-gear',
    panel: 'notif-prefs-panel',
    toggle: (type) => `notif-prefs-toggle-${type}`,
    back: 'notif-prefs-back',
};

export const EMBED = {
    openBtn: 'verify-embed-open',
    dialog: 'verify-embed-dialog',
    htmlSnippet: 'verify-embed-html',
    mdSnippet: 'verify-embed-md',
    copyHtml: 'verify-embed-copy-html',
    copyMd: 'verify-embed-copy-md',
    close: 'verify-embed-close',
};

export const WATCH = {
    toggleBtn: 'registry-watch-toggle',
    list: 'registry-watch-list',
    row: (sha) => `registry-watch-row-${sha.slice(0, 12)}`,
    unwatch: (sha) => `registry-watch-unwatch-${sha.slice(0, 12)}`,
    error: 'registry-watch-error',
};

export const DIGEST = {
    card: 'desk-digest-card',
    stat: (kind) => `desk-digest-stat-${kind}`,
    empty: 'desk-digest-empty',
};
